import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-center ga-3" }
const _hoisted_3 = { class: "font-size-12-400 d-flex justify-space-between w-100" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "alert-message font-size-12-400"
}
const _hoisted_7 = { class: "pt-12" }

import {reactive, onMounted, ref, computed, inject} from 'vue';
import {cartService} from '@/api/services/cart';
import {ordersService} from '@/api/services/order';
import {clientService} from '@/api/services/client';
import {useSettingsStore} from '@/api/store/settings';
import {Browser} from '@capacitor/browser';
import {getToken} from '@/api/services/auth';
import router from '@/router';
import ShopCartOrderSummary from "@/views/ShopComponents/ShopCartOrderSummary/ShopCartOrderSummary.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import Icon from "@/components/Icons/Icon.vue";
import ShopCartOrderShippingMethod from "@/views/ShopComponents/ShopCartOrderSummary/ShopCartOrderShippingMethod.vue";
import ShopCartAddShippingMethodModal
  from "@/views/ShopComponents/ShopCartOrderSummary/ShopCartAddShippingMethodModal.vue";
import {useUserStore} from "@/api/store/user";
import { load } from 'webfontloader';
import { useSnackbarStore } from '@/api/store/useSnackbarStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCreate',
  setup(__props) {

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const storedToken = getToken();

const snackBarPlugin = inject('snackbar') as ReturnType<typeof useSnackbarStore>;

const state = reactive({
  address: null as any,
  addresses: [] as any[],
  showProducts: false,
  editAddress: false,
  order: null as any | null,
  loadingOnRemove: false as boolean,
  processing: false as boolean,
});

const shippingState = reactive({
  shippingId: null as any | null,
  cartId: null as any | null,
  show: false,
});

const data = ref([]);


const processOrder = () => {

  if(state.address === null) {
    snackBarPlugin.errorSnackbar('Shipping address is required to complete this order.');
    return;
  }

  state.processing = true;
  ordersService.finalize(data.value[0].order_id, state.address.id).then((result) => {
    router.push({ name: 'order-view', params: { id: result.order.id } });
  }).catch((error) => {
    snackBarPlugin.errorSnackbar(error.message);
  }).finally(() => {
    state.processing = false;
  });
  /*
  cartService.processOrder(cartStore.items[0].order_id, state.address.id).then((result) => {
      openPurchase(storedToken as string, result.order.id);
      console.log('order processed', result);
  })
  .catch((error) => {
      console.log('order error', error);
  });*/
};

const getCarts = () => {
  
  cartService.index().then((response: any) => {
    data.value = response.data;
  }).catch((error: any) => {
    console.log(error);
  });
};

const getAddresses = async () => {
  const response = await clientService.addresses();
  state.addresses = response;
  state.addresses.map((address: any) => {
    address.title = address.one_line;
  });
  if (response.length > 0) {
    state.address = response.find((address: any) => address.type === 'shipping');
  }
};

const addShipping = (cartId: any) => {
  
  // Check if shipping address is available
  if(getShippingAddress.value === null) {
    snackBarPlugin.errorSnackbar('Shipping address is required to complete this order.');
    return;
  }

  shippingState.cartId = cartId;
  shippingState.shippingId = getShippingAddress.value.id;
  shippingState.show = true;
};

const removeShipping = (cartId: any, itemId: any) => {
  state.loadingOnRemove = true;
  cartService.removeItem(cartId, itemId).then(() => {
    getCarts();
    state.loadingOnRemove = false;
    snackBarPlugin.warningSnackbar('Shipping method removed successfully');
  }).catch((error: any) => {
    snackBarPlugin.errorSnackbar('Failed to remove shipping method');
    console.log(error);
  });
};

const getShippingAddress = computed(() => {
  return state.address ?? null;
})

const filteredData = computed(() => {
  return data.value.filter((item) => item.items.length > 0);
});

const hasShippingItems = computed(() => {
  return filteredData.value.some(
    cart => cart.items.some(
      item => item.product && (item.product.type == 'clinic_product' || item.product.type == 'supplement')
    )
  );
});

const isPaymentDisabled = computed(() => {

  if(!hasShippingItems.value) {
    return false;
  }
  
  return filteredData.value.some(cart => !cart.items.some(item => item.product?.type === 'shipping_method'));
});

onMounted(() => {
  getCarts();
  getAddresses();
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (data.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 0,
          class: "px-0 position-relative",
          style: {"background-color":"#F0F0F0","min-height":"100vh"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("section", {
                key: `order-${index}`
              }, [
                (item?.items.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 0,
                      class: "card-container"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "font-size-18-600 pt-0 pl-0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Part " + _toDisplayString(index + 1) + " of " + _toDisplayString(filteredData.value.length), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(ShopCartOrderSummary, {
                          item: item,
                          onMakePayment: processOrder
                        }, null, 8, ["item"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (hasShippingItems.value)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  class: "card-container pb-6"
                }, {
                  default: _withCtx(() => [
                    (getShippingAddress.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                          _createVNode(_component_v_card_title, { class: "font-size-18-600 pl-0" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" Shipping ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_card_title, { class: "font-size-14-600 pl-0" }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Shipping Address ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(Icon, { icon: "address-icon" }),
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", null, _toDisplayString(getShippingAddress.value.address_1) + ", " + _toDisplayString(getShippingAddress.value.address_2) + ", " + _toDisplayString(getShippingAddress.value.address_3), 1),
                                  _createElementVNode("p", _hoisted_4, _toDisplayString(getShippingAddress.value.post_code) + ", " + _toDisplayString(getShippingAddress.value.city) + ", ", 1),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(getShippingAddress.value.country), 1)
                                ]),
                                _createElementVNode("div", {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'client-details'})))
                                }, [
                                  _createVNode(_component_v_btn, {
                                    class: "text-white b-round-20 d-flex justify-end pr-1",
                                    elevation: "0",
                                    height: "32px",
                                    "x-small": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: _unref(settingsStore).settings.secondaryColor,
                                        icon: "fa fa-pencil"
                                      }, null, 8, ["color"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("section", null, [
                      _createVNode(_component_v_card_title, { class: "font-size-14-600 pl-0" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Shipping Method ", -1)
                        ]))]),
                        _: 1
                      }),
                      (isPaymentDisabled.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Please ensure that a shipping method is added to proceed with the order. "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (itemShipping, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `shipping-${index}`,
                          class: "font-size-12-400"
                        }, [
                          (itemShipping.items.length > 0)
                            ? (_openBlock(), _createBlock(ShopCartOrderShippingMethod, {
                                key: 0,
                                disabled: state.loadingOnRemove,
                                item: itemShipping,
                                "shipping-address": getShippingAddress.value,
                                "user-store": _unref(userStore),
                                class: "py-4",
                                onDelete: removeShipping,
                                onAddShipping: addShipping
                              }, null, 8, ["disabled", "item", "shipping-address", "user-store"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("p", { class: "p-text-lg text-center" }, "Cart not found.", -1)
          ]))]),
          _: 1
        })),
    _createElementVNode("section", _hoisted_7, [
      _createVNode(_component_v_overlay, {
        "model-value": state.processing,
        class: "align-center justify-center",
        color: "deep-purple-accent-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            indeterminate: "",
            size: "64"
          })
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createVNode(ButtonFixed, {
        disabled: isPaymentDisabled.value || data.value.length === 0 || state.processing,
        "custom-class": "text-white primary-button",
        text: "Complete Order",
        onClick: processOrder
      }, null, 8, ["disabled"])
    ]),
    (shippingState.show)
      ? (_openBlock(), _createBlock(ShopCartAddShippingMethodModal, _mergeProps({
          key: 2,
          modelValue: shippingState.show,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shippingState.show) = $event))
        }, shippingState, { onAddShipping: getCarts }), null, 16, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})